<div class="core-tire-dialog">
  <div class="core-tire-dialog-header flex-between-center">
    <p class="m-0 font-bold d-flex align-self-center">
      <i class="far fa-undo font-20 pr-2 font-gray-45"></i>
      <span>Core & Return tracking</span>
    </p>

    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="core-tire-dialog-body flex-column">
    <!-- Basic info -->
    <div class="ui-g-12 p-0">
      <h5 class="input-heading">Basic info</h5>
    </div>

    <div class="ui-g-12 p-0 input-default-style mb-0">
      <!-- Brand -->
      <div class="ui-g-4 pl-0">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.category?.name }">
          <div class="icon flex-center-start">
            <i class="far fa-copyright height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-tire-return-code" type="text" placeholder="Brand" theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.category?.name" [disabled]="true"> </app-input>
          </div>
        </div>
      </div>

      <!-- Model -->
      <div class="ui-g-4">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.model }">
          <div class="icon flex-center-start">
            <i class="far fa-tire height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-tire-return-category" type="text" placeholder="Model" theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.model" [disabled]="true"> </app-input>
          </div>
        </div>
      </div>

      <!-- Supplier -->
      <div class="ui-g-4 pr-0">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.supplier?.name }">
          <div class="icon flex-center-start">
            <i class="far fa-warehouse height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-tire-return-supplier" type="text" placeholder="Supplier*" theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.supplier?.name" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>
    </div>

    <!-- Seasonality Info section -->
    <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0" style="margin-bottom: 20px;">
      <div class="ui-g-12 p-0 input-control-container">
        <div class="ui-g-12 p-0 flex-start-center">
          <div class="icon flex-center-start mt-3">
            <i class="far fa-sun-cloud height-icon"></i>
          </div>

          <div class="width-100p pl-1">
            <h5 class="font-11 font-gray-45 mb-1">Seasonality</h5>
            <div class="ui-g-12 p-0 seasonality-wrapper">
              <div class="ui-g-4 p-1 seasonality-tab text-center pointer"
                [ngClass]="{ active: item?.seasonality === 'summer' }">
                <i class="far fa-sun font-gray-35"></i>
                <span class="pl-6p">Summer</span>
              </div>

              <div class="ui-g-4 p-1 seasonality-tab text-center pointer"
                [ngClass]="{ active: item?.seasonality === 'winter' }">
                <i class="far fa-cloud-snow font-gray-35"></i>
                <span class="pl-6p">Winter</span>
              </div>

              <div class="ui-g-4 p-1 seasonality-tab text-center pointer"
                [ngClass]="{ active: item?.seasonality === 'all' }">
                <i class="far fa-cloud-sun-rain font-gray-35"></i>
                <span class="pl-6p">All seasons</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Seasonality Info section ends -->

    <!-- Tire info -->
    <div class="ui-g-12 p-0">
      <h5 class="input-heading">Tire info</h5>
    </div>

    <div class="ui-g-12 p-0 input-default-style mb-0">
      <!-- Tire Size -->
      <div class="ui-g-4 pl-0">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.size }">
          <div class="icon flex-center-start">
            <i class="far fa-ruler height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-tire-return-cost" type="text" placeholder="Size" theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.size" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Part Number -->
      <div class="ui-g-4">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.code }">
          <div class="icon flex-center-start">
            <i class="far fa-qrcode height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-tire-return-qty" type="text" placeholder="Part no." theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.code" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Tire name -->
      <div class="ui-g-4 pr-0 flex-start-center">
        <div class="field-wrapper-with-bg flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-align-justify height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field" [ngClass]="{ empty: !item?.title }">
            <app-input id="core-tire-return-total-cost" type="text" placeholder="Tire name" theme="light"
              [fontSize]="14" [floatingLabel]="true" [value]="item?.title" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>
    </div>

    <!-- Pricing -->
    <div class="ui-g-12 p-0">
      <h5 class="input-heading">Pricing</h5>
    </div>

    <div class="ui-g-12 p-0 input-default-style mb-0">
      <!-- Cost -->
      <div class="ui-g-4 pl-0">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.cost }">
          <div class="icon flex-center-start">
            <i class="far fa-receipt height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-tire-return-cost" type="text" placeholder="Cost*" theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.cost || 0 | currency: usd" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Default qty -->
      <div class="ui-g-4">
        <div class="field-wrapper-with-bg flex-start-center" [ngClass]="{ empty: !item?.count }">
          <div class="icon flex-center-start">
            <i class="far fa-boxes height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-tire-return-qty" type="text" placeholder="Default Qty" theme="light" [fontSize]="14"
              [floatingLabel]="true" [value]="item?.count || 0 | number: '1.2-2'" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Total cost -->
      <div class="ui-g-4 pr-0 flex-start-center">
        <div class="field-wrapper-with-bg flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-receipt height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field" [ngClass]="{ empty: !item?.totalCost }">
            <app-input id="core-tire-return-total-cost" type="text" placeholder="Total cost" theme="light"
              [fontSize]="14" [floatingLabel]="true" [value]="item?.totalCost || 0 | currency: usd" [disabled]="true">
            </app-input>
          </div>
        </div>
      </div>
    </div>

    <div class="order-detail-wrapper">
      <div class="ui-g-12 p-0">
        <h5 class="input-heading mb-2">Order details</h5>
      </div>

      <div class="ui-g-12 p-0 input-default-style">
        <!-- Qty ordered -->
        <div class="ui-g-6 p-0 flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-boxes height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="qty-ordered" type="text" placeholder="Qty ordered" theme="light" [selectTextOnFocus]="true"
              [value]="focus?.qtyOrdered ? item?.qtyOrdered : item?.qtyOrdered" [mask]="focus?.qtyOrdered ? '0*' : ''"
              [fontSize]="14" [floatingLabel]="true" [value]="item?.qtyOrdered"
              [disabled]="item?.itemSource === 'PartsTech'" (appFocus)="handleFocus('qtyOrdered')"
              (appBlur)="handleBlur('qtyOrdered')" (appChange)="handleChange('qtyOrdered', $event)">
            </app-input>
          </div>
        </div>

        <!-- Supplier invoice -->
        <div class="ui-g-6 p-0 flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-file-invoice-dollar height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="supplier-invoice" type="text" placeholder="Supplier's invoice #" theme="light"
              [maxLength]="25" [fontSize]="14" [floatingLabel]="true" [value]="item?.supplierInvoiceNo"
              (appChange)="handleChange('supplierInvoiceNo', $event)">
            </app-input>
          </div>
        </div>
      </div>

      <div class="ui-g-12 p-0">
        <h5 class="input-heading mb-2">Return details</h5>
      </div>

      <div class="ui-g-12 p-0 input-default-style">
        <!-- Qty return -->
        <div class="ui-g-6 p-0 flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-boxes height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="qty-returned" type="text" placeholder="Qty returned" theme="light"
              [autoFocus]="focus?.itemReturnQty" [selectTextOnFocus]="true"
              [value]="focus?.itemReturnQty ? item?.itemReturnQty : item?.itemReturnQty"
              [mask]="focus?.itemReturnQty ? '0*' : ''" [fontSize]="14" [floatingLabel]="true"
              [value]="item?.itemReturnQty" [isInvalid]="errors?.itemReturnQty" [errorMessage]="errors?.itemReturnQty"
              (appFocus)="handleFocus('itemReturnQty')" (appBlur)="handleBlur('itemReturnQty')"
              (appChange)="handleChange('itemReturnQty', $event)">
            </app-input>
          </div>
        </div>

        <!-- Return date -->
        <div class="ui-g-6 p-0 flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-calendar-alt height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field return-date" #startDateCalendarContainer>
            <div class="float-static-labl">
              Return date
            </div>
            <div class="calendar-input core-calendar">
              <p-calendar id="start-date" dateFormat="M dd, yy" [(ngModel)]="item.returnDate" #startDateCalendar>
              </p-calendar>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g-12 p-0">
        <h5 class="input-heading mb-2">Core tracking</h5>
      </div>

      <div class="ui-g-12 p-0 input-default-style">
        <!-- Core tracking -->
        <div class="ui-g-6 p-0 flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-tools height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-input id="core-tracking-cost" type="text" placeholder="Cost" theme="light"
              [autoFocus]="focus?.coreCost" [selectTextOnFocus]="true"
              [value]="focus?.coreCost ? item?.coreCost : item?.coreCost | currency: usd"
              [allowDecimal]="focus?.coreCost ? true: false"
              [fontSize]="14" [floatingLabel]="true" [value]="item?.coreCost"
              [isInvalid]="errors?.coreCost" [errorMessage]="errors?.coreCost"
              [disabled]="item?.itemSource === 'PartsTech'" (appFocus)="handleFocus('coreCost')"
              (appBlur)="handleBlur('coreCost')" (appChange)="handleChange('coreCost', $event)">
            </app-input>
          </div>
        </div>

        <!-- Core retrieval status -->
        <div class="ui-g-6 p-0 flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-ballot-check height-icon"></i>
          </div>

          <div class="width-100p pl-1 pr-2 position-relative cost-field">
            <app-dropdown id="core-retrieval-status" listId="core-retrieval-status-list" field="label"
              scrollHeight="100px" theme="light" styleClassSelectedView="pl-0" styleClassValue="pl-0"
              label="Core retrieval status" placeholder="Core retrieval status" position="top" [floatingLabel]="true"
              [setPositionDynamically]="false" [options]="coreRetrievalStatus" [isDropdownIconVisible]="true"
              [fontSize]="14" [value]="item?.coreRetrievalStatus" [listItemFontSize]="12"
              (appSelect)="handleChange('coreRetrievalStatus', $event)">
            </app-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="core-tire-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>

    <button class="btn btn-primary btn-submit" (click)="handleSave()">
      Save
      <i class="fal fa-spinner rotate" *ngIf="isProcessing"></i>
    </button>
  </div>
</div>
